<ng-template #resetPasswordModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Reset your Password</h4>
        <button type="button" class="btn-close" aria-label="Close" title="Close Modal" (click)="modal.dismiss('Cross click');fromReset()"></button>
    </div>
    <div class="modal-body">
        <form [formGroup]="formGroup" (keydown)="enterKeyPress($event)">

        <div class="row modal-form-row">
            <div class="col-12">
                <div>
                    <app-input-password
                    [fieldValue]="item.password"
                    [fieldText]="'password'"
                    [fControl]="formGroup.controls['Password']" 
                    [inputClass]="'form-control'" 
                    [inputPlaceholder]="'Enter New Password'" 
                    [inputLabel]="'New Password'" [labelClass]="'form-label'" 
                    (onTextChange)="onTextValueChange($event)" 
                    [minLengthValidationMsg]="'Password must be at least 6 characters long.'"
                    [maxLengthValidationMsg]="'Password must be at most 25 characters long.'"
                    [patternValidationMsg]="'Password can contain letters, numbers or combination of letters and numbers.'"
                    >
                    </app-input-password>
                </div>
            </div>
            <div class="col-12">
                <div>
                    <app-input-password
                    [fieldValue]="item.confirmPassword" 
                    [fieldText]="'confirmPassword'" 
                    [fControl]="formGroup.controls['NewPassword']" 
                    [inputClass]="'form-control'" 
                    [inputPlaceholder]="'Enter Confirm New Password'" 
                    [inputLabel]="'Confirm New Password'" 
                    [labelClass]="'form-label'" 
                    (onTextChange)="onTextValueChange($event)" 
                    [minLengthValidationMsg]="'Confirm Password must be at least 6 characters long.'"
                    [maxLengthValidationMsg]="'Confirm Password must be at most 25 characters long.'"
                    [customErrorValidationMsg]="'The new password and confirm new password do not match.'"
                    [patternValidationMsg]="'Password can contain letters, numbers or combination of letters and numbers.'" 
                    ></app-input-password>
                </div>
            </div>
        </div>
        <div class="btn-grps">
            <app-button [btnText]="'Confirm'" [btnTitle]="'Confirm'" [btnCss]="'btn btn-primary w-100 btn-lg'" [isDisable]="isDisableConfirmBtn" (onBtnClick)="onConfirmClick()"></app-button>
            <app-button [btnText]="'Cancel'" [btnTitle]="'Cancel'" [btnCss]="'btn btn-text w-100 btn-lg btn-md'" (onBtnClick)="onCancelClick();modal.dismiss('Cross click');"></app-button>

        </div>
        </form>
    </div>
</ng-template>
